import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import type {
  ItemDefinitionViewType} from 'src/app/item-tracker/ItemDefinitionForm';
import {
  ItemDefinitionForm
} from 'src/app/item-tracker/ItemDefinitionForm';
import {itemDefinitionDocumentTitle} from 'src/app/item-tracker/itemDefinitionHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {ItemDefinitionRouteService} from 'src/shared/services/RouterService/ItemDefinitionRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const ItemDefinitionViewPage: React.FC = () => {
  useSetDocumentTitle(`${itemDefinitionDocumentTitle} - View`);
  const {id, view} = useParams();

  const mode: ViewModeType = 'view';
  const router = new ItemDefinitionRouteService(false, mode, {
    view: view as ItemDefinitionViewType,
  });

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      {id !== undefined && (
        <ItemDefinitionForm
          id={Number(id)}
          mode="view"
          view={view as ItemDefinitionViewType}
          router={router}
        />
      )}
    </ContentWrapper>
  );
};

export default ItemDefinitionViewPage;

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.ItemDefinitionView(':id', ':view'),
  element: <ItemDefinitionViewPage />,
  isPrivate: true,
  module: ModuleEnum.ItemTrackerDefinitions,
  operation: PermissionOperationEnum.View,
});
